module.exports = __webpack_public_path__ + "static/media/marriot_thumb.36badd65.jpeg";